import { type PropsWithChildren } from 'react';

import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';

//#region Typings

/**
 * Accepted properties for the Select Suffix
 * @public
 */
export type SelectSuffixProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId &
  BehaviorTrackingProps;
//#endregion

/**
 * The `Select.Suffix` component allows you to specify any content, that should
 * be prefixed in the trigger element. The `Select.Suffix` component is only valid
 * within the `Select.Trigger` and `Select.Option` element.
 * @example
 * ```tsx
 * <Select.DisplayValue>
 *   <Select.Suffix>
 *     <WhatsNewIcon />
 *   </Select.Suffix>
 * </Select.DisplayValue>
 * ```
 * @public
 */
export function SelectSuffix(props: SelectSuffixProps): null {
  return null;
}
